import { forwardRef, useImperativeHandle } from 'react'
import GameContainer from './components/GameContainer';
import { useRef } from 'react';

const Game = forwardRef(function Game({ onAnswer }, ref) {

  const GameContainerRef = useRef(null);
  useImperativeHandle(ref, () => ({
    animateEntry: async () => {
      GameContainerRef.current.animateEntry();
    },
    animateExit: async () => {
    }
  }));

  return (
    <GameContainer
      ref={GameContainerRef}
      onAnswer={onAnswer}
    />
  )
})

export default Game